(function ($, Drupal, drupalSettings) {
  'use strict';

  Theme.all = function (common, options) {
    // Héritage
    this.common = common;

    // Selecteurs
    this.selectors = {
      // EXEMPLES : Data,Hover; Focus...
    };

    // Éléments
    this.elements = {
      html: $('html'),
      body: $('body'),
      blockView: $('div.block-view-display-list-news'),
      blockGalery: $('.paragraph--type--block-galery .galery--content'),
      blockSlider: $('.paragraph--type--block-slider').not('.style-slider-2'),
      blockSliderNumber: $('.paragraph--type--block-slider.style-slider-2'),
      blockTestimonials: $('.block-testimonials--content'),
      formMobileOpenLandingPage: $('#call-to-action-landing-page'),
      formMobileCloseLandingPage: $('#close-to-action-landing-page'),
      formLandingPage: $('.submit-landing'),
    };
    this.elements.viewForm = this.elements.blockView.find('form.views-exposed-form');
    //console.log(this.elements.viewForm);

    // Variables
    this.customForm = undefined;
  };

  Theme.all.prototype = {
    init: function () {
      this.initMenuMain();
      this.initHeader();
      this.blockAnchorsHandler();
      // if ($('#block-drup-theme-menu-main').length) {
      //   this.blockMenuMainHandler();
      // }
      this.blockSliderHandler();
      this.blockSliderNumberHandler();
      this.blockTestimonialsHandler();
      this.blockFaqHandler();
      this.blockVideoHandler();
      this.blockSliderReinssuranceRefreshHandler();
      this.blockSliderContainerExpertiseRefreshHandler();
      this.blockSliderContainerExpertiseRefreshHandlerhome();
      this.blockSliderContainerServicesExpertise();
      this.blockSliderContainerServicesFiliales();
      this.blockSliderContainerReference();
      this.blockSliderCardViewRefreshHandler('view-display-latest-news', 1024);
      this.blockSliderCardViewRefreshHandler('view-display-new-last-by-agency');
      this.blockSliderCardViewRefreshHandler('view-display-new-random');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-expertise');
      this.blockSliderCardViewRefreshHandler('view-display-customer-random');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-solution');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-agency');
      this.formHandler();
      this.modalHandler();
      this.articleShareHandler();
      this.navFooterHandler();
      this.blockSearchHandler();
    },

    load: function () {
      console.log('load');
      this.blockGaleryHandler();
      this.customFormHandler();
      this.blockSliderReinssuranceRefreshHandler();
      this.blockSliderContainerExpertiseRefreshHandler();
      this.blockSliderContainerExpertiseRefreshHandlerhome();
      this.blockSliderContainerServicesExpertise();
      this.blockSliderContainerServicesFiliales();
      this.blockSliderContainerReference();
      this.blockSliderCardViewRefreshHandler('view-display-latest-news', 1024);
      this.blockSliderCardViewRefreshHandler('view-display-new-last-by-agency');
      this.blockSliderCardViewRefreshHandler('view-display-new-random');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-expertise');
      this.blockSliderCardViewRefreshHandler('view-display-customer-random');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-solution');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-agency');
    },
    autoload: function (options) {
      console.log('autoload');
    },

    /**
     * Block Menu Main
     */
    initMenuMain: function () {
      /***** Menu desktop *****/
      // Niveau 0
      $('body').on('mouseover touch focus', '#block-drup-theme-menu-main .level0--link', function (e) {
        e.preventDefault();

        var level0Item = $(this).closest('.level0--item');

        if (!level0Item.hasClass('hover')) {
          $(this).closest('.level0').find('.level0--item.hover').removeClass('hover');
          //level0Item.removeClass('inactive').addClass('hover');
          //$(this).closest('.level0').find('.level0--item:not(.hover)').addClass('inactive');
          level0Item.addClass('hover');

          $('body').addClass('menu-main-opened');
        }

        // fermeture menu du header top
        $('.header-site-top nav').find('.level0--item.open').removeClass('open');
      });

      // Niveau 1
      $("body").on("mouseover touch focus", "#block-drup-theme-menu-main .level1--link", function (e) {
        e.preventDefault();

        let level1Item = $(this).closest('.level1--item');

        if (!level1Item.hasClass('hover')) {
          // fermeture du menu déjà sélectionné auparavant
          let level1ItemSelected = $(this)
            .closest('.level1')
            .find('.level1--item.hover');
          if (level1ItemSelected.length) {
            level1ItemSelected.removeClass("hover");
          }

          // ajustement de la hauteur du menu
          // let menuChild = level1Item.find($(".menu-dropdown-1"));
          // let menuParent = level1Item
          //   .closest(".menu-dropdown-0")
          //   .find(".menu-dropdown--wrapper");
          // let minHeightMenu = 0;
          // if (menuChild.length) {
          //   let megaMenuChilds = level1Item.closest(".menu-dropdown--wrapper");
          //   let marginTopMegaMenuChilds = megaMenuChilds.css("padding-top").replace("px", "");
          //   minHeightMenu = parseInt(menuChild.outerHeight()) + (parseInt(marginTopMegaMenuChilds) * 2);
          //   minHeightMenu += "px";
          //   menuParent.css("min-height", minHeightMenu);
          // }
          // else {
          //   menuParent.css("min-height", "400px");
          // }

          // ouverture du menu sélectionné
          level1Item.addClass("hover");

          // si le menu a plus de 2 enfants : on cache le push
          if(level1Item.hasClass('parent')){
            level1Item.parent().parent().parent().find('.megamenu-push').addClass("hide-push");
          }

        }
      });

      // Niveau 2
      $("body").on("mouseover touch focus", "#block-drup-theme-menu-main .level2--link", function (e) {
        e.preventDefault();

        let level2Item = $(this).closest('.level2--item');

        if (!level2Item.hasClass('hover')) {
          // fermeture du menu déjà sélectionné auparavant
          let level2ItemSelected = $(this)
            .closest('.level2')
            .find('.level2--item.hover');
          if (level2ItemSelected.length) {
            level2ItemSelected.removeClass("hover");
          }

          // ouverture du menu sélectionné
          level2Item.addClass("hover");
        }
      });

      // fermeture du menu
      $('body').on('mouseover touch', function(e) {
        if (!e.target.closest('#block-drup-theme-menu-main')) {
          if ($('#block-drup-theme-menu-main .level0--item.hover').length) {
            //setTimeout(function () {
            //$('#block-drup-theme-menu-main .level0--item').removeClass('hover').removeClass('inactive');
            $('#block-drup-theme-menu-main .level0--item').removeClass('hover');
            //}, 100);


            $('body').removeClass('menu-main-opened');
          }
          if ($("#block-drup-theme-menu-main .level1--item.hover").length) {
            $("#block-drup-theme-menu-main .level1--item").removeClass("hover");
          }

          if ($("#block-drup-theme-menu-main .level2--item.hover").length) {
            $("#block-drup-theme-menu-main .level2--item").removeClass("hover");
          }
        }
      });

      /** Menu mobile **/
      /* préparation du menu mobile */
      $('#block-drup-theme-menu-main').after($('#block-drup-theme-menu-main').clone().attr('id', 'block-menu-main-mobile'));
      $('#block-menu-main-mobile .level0').append($('#block-drup-theme-menu-professional .level0--item').clone());
      $('#block-menu-main-mobile .level0').append($('#block-drup-theme-particular .level0--item').clone());

      // suppression des éléments en trop
      $('#block-menu-main-mobile .megamenu-presentation').remove();
      $('#block-menu-main-mobile .megamenu-push').remove();
      $('#block-menu-main-mobile .level1--outer > .level1').unwrap();
      $('#block-menu-main-mobile .megamenu-childs > .level1').unwrap();
      $('#block-menu-main-mobile .menu-dropdown--wrapper > .level1').unwrap();
      $('#block-menu-main-mobile .menu-dropdown-0 > .level1').unwrap();
      $('#block-menu-main-mobile .menu-dropdown-1 > .level2').unwrap();
      $('#block-menu-main-mobile .menu-dropdown-2 > .level3').unwrap();
      $('#block-menu-main-mobile .menu-dropdown-3 > .level4').unwrap();

      // déplacement autres menus dans menu mobile
      $('#block-menu-main-mobile .level0').append($('#block-drup-theme-menu-secondary .level0--item').clone());


      let menuMobileTopLeft = $('<div class="menu-main-mobile--top-left"></div>')
        .append($('#block-drup-theme-logo').clone().attr('id', 'block-logo-mobile'))
        .append($('#block-language-selector').clone().attr('id', 'block-language-selector-mobile'));
      let menuMobileTop = $('<div class="menu-main-mobile--top"></div>')
        .append(menuMobileTopLeft)
        .append($('.link-recall').clone().removeClass('hide-on-mobile level0--link'))
        .append($('<a class="btn-menu-mobile-close" href="#"><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#burger-close"></use></svg></a>'));
      $('body').prepend(menuMobileTop);

      // let menuMobileBottom = $('<div class="menu-main-mobile--bottom"></div>')
      //   .append($('#block-drup-theme-menu-shortcuts').clone().attr('id', 'block-menu-shortcuts-mobile'));
      // menuMobileBottom.find('.hide-on-mobile').removeClass('hide-on-mobile');
      // $('body').append(menuMobileBottom);

      var barSearch = $('#site-search').clone();
      $('#block-menu-main-mobile .level0--item').last().after(barSearch);

      // construction du menu mobile avec Mmenu light
      const menu = new MmenuLight(
        document.querySelector("#block-menu-main-mobile"),
        "(max-width: " + (BREAKPOINT_TABLETHOR - 1) + "px)"
      );
      const navigator = menu.navigation({
        title:  '',
        theme:  'dark',
        selected: 'active'
      });
      const drawer = menu.offcanvas({
        position: 'left'
      });

      $('.level0').on('scroll', function () {
        if ($(this).scrollTop() >= 45) {
          $('.menu-main-mobile--top').addClass('minimized');
        }
        else {
          $('.menu-main-mobile--top').removeClass('minimized');
        }
      });

      $('.btn-menu-mobile').on('click touch', function (e) {
        e.preventDefault();
        drawer.open();
      });
      $('.btn-menu-mobile-close').on('click touch', function (e) {
        e.preventDefault();
        drawer.close();
      });

    },

    /**
     * header
     */
    initHeader: function () {
      // $("body").on("mouseover touch focus", ".header-site", function (e) {
      //   if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
      //     e.preventDefault();
      //
      //     //if (!$(".header-site").hasClass("with-bg-white") && !$('body').hasClass("node-type-magazine")) {
      //     if (!$(".header-site").hasClass("with-bg-white")) {
      //       $(".header-site").addClass("with-bg-white");
      //     }
      //   }
      //   else {
      //     $(".header-site").removeClass("with-bg-white");
      //   }
      // });
      //
      // $("body").on("mouseover touch", function (e) {
      //   if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
      //     if (!e.target.closest(".header-site")) {
      //       $(".header-site").removeClass("with-bg-white");
      //     }
      //   }
      //   else {
      //     $(".header-site").removeClass("with-bg-white");
      //   }
      // });

      this.refreshHeader(false);
      $(window).on("scroll", function () {
        var all = Drupal.Theme.load("all");
        all.refreshHeader(false);
      });
    },

    refreshHeader: function (forceSticky) {
      if ($(window).scrollTop() <= 0) {
        $(".header-site").removeClass("is-sticky");
      }
      else if ($(window).scrollTop() > previousScrollTop &&
        $(window).scrollTop() > $(".header-site").outerHeight() &&
        forceSticky !== true) {

        if (!$('body').hasClass('menu-main-mobile-active')) {
          $(".header-site").addClass('hide');
        }
      }
      else {
        let makeSticky = false;
        $(".header-site").removeClass('hide');

        if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
          makeSticky = true;
        }
        else if (!$('body').hasClass('menu-main-mobile-active')) {
          makeSticky = true;
        }
        if (makeSticky && !$(".header-site").hasClass("is-sticky")) {
          $(".header-site").addClass("is-sticky");
        }
      }
      previousScrollTop = $(window).scrollTop();
    },

    /**
     * Block Anchors
     */
    blockAnchorsHandler: function () {
      var self = this;

      $('.paragraph--type--item-container-header[id]').each(function () {
        //paragraph--type--container-anchors
        var idAnchor = $(this).attr('id');
        var labelAnchor = $(this).attr('data-label');
        var blocAnchorsPrev = $(this).closest('.paragraph-root').prevAll('.paragraph--type--container-anchors');

        if (blocAnchorsPrev.length) {
          var blocAnchorWrapper = blocAnchorsPrev.first().find('.paragraph--type--item-container-header');
          if (!blocAnchorWrapper.find('.anchors').length) {
            blocAnchorWrapper.append('<div class="anchors btn-group btn-color-border-grey btn-icon-long-arrow"></div>');
          }
          blocAnchorWrapper.find('.anchors').append('<a class="btn" href="#' + idAnchor + '">' + labelAnchor + '</a>')
        }
      });

      $('.anchors a').on('click touch', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        var topAnchor = $(target).offset().top - $('.pre-header').outerHeight() - 20;

        $('html, body').stop().animate({scrollTop: topAnchor}, 400);
      });

    },

    /**
     * Block Galery
     */
    blockGaleryHandler: function () {
      var self = this;
      if (self.elements.blockGalery.length) {

        // init Masonry
        var gridGalery = self.elements.blockGalery.masonry({
          columnWidth: self.elements.blockGalery.find('.paragraph--type--block-image')[1],
          horizontalOrder: true,
          percentPosition: true,
        });

        // layout Masonry after each image loads
        gridGalery.imagesLoaded().progress( function() {
          gridGalery.masonry();
        });
      }
    },

    /**
     * Block Slider
     */
    blockSliderHandler: function () {
      var self = this;

      if (self.elements.blockSlider.length) {
        self.elements.blockSlider.each(function () {

          // récup param autoplay
          var autoplayTimeout = 0;
          $(this).attr('class').split(' ').forEach(function (item) {
            if (item.indexOf('autoplay-') >= 0) {
              switch (item.replace('autoplay-', '')) {
                case 'slow' :
                  autoplayTimeout = 10000;
                  break;
                case 'fast' :
                  autoplayTimeout = 3000;
                  break;
                case 'normal' :
                  autoplayTimeout = 5000;
                  break;
                default :
                  autoplayTimeout = 0;
              }
            }
          });

          // slide video
          $(this).on('click touch', '.link-video-embed.open-here', function (e) {
            e.preventDefault();

            $(this).addClass('hide');

            // stop autoplay sur le slider
            if ($(this).closest('.block-slider--content').hasClass('owl-carousel')) {
              $(this).closest('.block-slider--content').trigger('stop.owl.autoplay');
            }

            // lecture video
            $(this).closest('.paragraph--type--item-slider-slide').find('.content-video-embed').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
            $(this).closest('.paragraph--type--item-slider-slide').addClass('play-video');
          });

          // init slider
          $(this).find('.block-slider--content-slide').addClass('owl-carousel').owlCarousel({
            autoplay: (autoplayTimeout > 0),
            autoplayTimeout: autoplayTimeout,
            responsiveClass: true,
            autoplayHoverPause: true,
            autoHeight: true,
            nav: true,
            dots: false,
            autoWidth: false,
            items: 1,
            responsive: {
              0: {
                loop: false,
              },
              768: {
                loop: false,
              }
            },
            onChange: function (event) {
              //console.log(event.property.name);
              // si navigation dans slider en pause  suite à une lecture d'une vidéo : restart autoplay et stop vidéo
              if (event.property.name == 'position') {
                // restart autoplay
                if ($(event.target).autoplay) {
                  $(event.target).trigger('play.owl.autoplay');
                }

                // stop video
                //console.trace($(event.target));
                $(event.target).find('.paragraph--type--item-slider-slide').removeClass('play-video');
                $(event.target).find('.paragraph--type--item-slider-slide .content-video-embed').empty();
                $(event.target).find('.link-video-embed.hide').removeClass('hide');
              }
            }
          });
        });
      }
    },

    /**
     * Gestionnaire de CustomForm
     */
    customFormHandler: function () {
      var self = this;

      self.customForm = self.elements.viewForm.customForm();
      self.customForm.setSupport('checkbox', {
        beforeWrap: function () {
          this.wrapper.removeClass(this.customFormCheck.settings.classes.prefix + '--' + this.customFormCheck.element.type);
          this.wrapper.addClass('tag');
        },
        onClick: function () {
          this.customFormCheck.element.context.find('input[type="submit"]').trigger('click');
        }
      });
    },

    /**
     * Block Slider
     */
    blockSliderNumberHandler: function () {
      var self = this;

      if (self.elements.blockSliderNumber.length) {
        self.elements.blockSliderNumber.each(function () {

          // récup param autoplay
          var autoplayTimeout = 0;
          $(this).attr('class').split(' ').forEach(function (item) {
            if (item.indexOf('autoplay-') >= 0) {
              switch (item.replace('autoplay-', '')) {
                case 'slow' :
                  autoplayTimeout = 10000;
                  break;
                case 'fast' :
                  autoplayTimeout = 3000;
                  break;
                case 'normal' :
                  autoplayTimeout = 5000;
                  break;
                default :
                  autoplayTimeout = 0;
              }
            }
          });

          // slide video
          $(this).on('click touch', '.link-video-embed.open-here', function (e) {
            e.preventDefault();

            $(this).addClass('hide');

            // stop autoplay sur le slider
            if ($(this).closest('.block-slider--content').hasClass('owl-carousel')) {
              $(this).closest('.block-slider--content').trigger('stop.owl.autoplay');
            }

            // lecture video
            $(this).closest('.paragraph--type--item-slider-slide').find('.content-video-embed').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
            $(this).closest('.paragraph--type--item-slider-slide').addClass('play-video');
          });

          // init slider
          $(this).find('.block-slider--content-slide').addClass('owl-carousel').owlCarousel({
            autoplay: (autoplayTimeout > 0),
            autoplayTimeout: autoplayTimeout,
            responsiveClass: true,
            autoplayHoverPause: true,
            nav: $(this).hasClass('arrows'),
            dots: false,
            autoWidth: false,
            items: 1,
            autoHeight: true,
            responsive: {
              0: {
                loop: false,
              },
              768: {
                loop: false,
              }
            },
          });
        });
      }
    },

    /**
     * Block Testimonials
     */
    blockTestimonialsHandler: function () {
      var self = this;

      if (self.elements.blockTestimonials.length) {
        self.elements.blockTestimonials.addClass('owl-carousel').owlCarousel({
          loop: false,
          autoplay: true,
          responsiveClass: true,
          autoplayHoverPause: true,
          autoHeight: false,
          nav: true,
          dots: false,
          autoWidth: false,
          items: 1
        });
      }
    },

     /**
     * Block Reassurance
     */
     blockSliderReinssuranceRefreshHandler: function () {
      var containerReinssurance = $('.paragraph--type--container-reinssurance .paragraph--row');
      var params = {
        loop: false,
        autoplay: true,
        responsiveClass: true,
        nav: true,
        dots: false,
        autoWidth: false,
        responsive: {
          0: {
            items: 1,
          }
        }
      };

      if ($('.paragraph--type--container-reinssurance .paragraph--row')[0]){
        // Init before resize
        if ($(window).width() < 800) {
          containerReinssurance.addClass('owl-carousel').owlCarousel(params);
        }
        $(window).on('resize', function () {
          if ($(window).width() < 800 && !containerReinssurance.hasClass('owl-carousel')) {
            containerReinssurance.addClass('owl-carousel').owlCarousel(params);
          } else if ($(window).width() > 800) { // Not mobile but slider built = destroy
            containerReinssurance.trigger('destroy.owl.carousel').removeClass('owl-carousel');
          }
        });
      }
    },

    /**
     * Block Col Expertise
     */

    blockSliderContainerExpertiseRefreshHandler: function () {
      if($("body:not(.home) .paragraph--type--container-expertise .wrapper-block").length) {
        var containerExpertise = $('.paragraph--type--container-expertise .paragraph--row');
        var params = {
          stagePadding: 0,
          margin: 0,
          loop: false,
          autoplay: false,
          nav: true,
          responsiveClass: true,
          dots: false,
          responsive: {
            0: {
              items: 1,
              margin: 0,
              autoWidth: true,
            }
          }
        };

        // Init before resize



        if($('.paragraph--type--block-card-expertise').length >= 6 || $(window).width() < 768) {
          containerExpertise.addClass('owl-carousel').owlCarousel(params);
        }

        /*}*/

        $(window).on('resize', function () {
          if ($(window).width() < 768 && !containerExpertise.hasClass('owl-carousel')) {
            containerExpertise.addClass('owl-carousel').owlCarousel(params);
          } else if ($(window).width() > 768) { // Not mobile but slider built = destroy
            if($('.paragraph--type--container-expertise .wrapper-block  .owl-item:not(.cloned)').length < 5 ) {
              containerExpertise.trigger('destroy.owl.carousel').removeClass('owl-carousel');
            }
          }
        });
      }
    },

    blockSliderContainerExpertiseRefreshHandlerhome: function () {
      if($(".home .paragraph--type--container-expertise .wrapper-block").length) {
        var containerExpertiseHome = $('.paragraph--type--container-expertise .wrapper-block .paragraph--row');
        var params = {
          stagePadding: 0,
          margin: 0,
          loop: false,
          autoplay: false,
          nav: true,
          responsiveClass: true,
          dots: false,
          responsive: {
            0: {
              items: 1,
              margin: 0,
              autoWidth: true,
            },
            768: {
              items: 1,
              margin: 0,
              autoWidth: true,
            }
          }
        };

        // Init before resize


        if($('.wrapper-block .paragraph--type--block-card-expertise').length >= 5  || $(window).width() < 768 ) {
          containerExpertiseHome.addClass('owl-carousel').owlCarousel(params);
        }


        /*}*/

        $(window).on('resize', function () {
          if ($(window).width() < 768 && !containerExpertiseHome.hasClass('owl-carousel')) {
            containerExpertiseHome.addClass('owl-carousel').owlCarousel(params);
          } else if ($(window).width() > 768) { // Not mobile but slider built = destroy
            if($('.paragraph--type--container-expertise .wrapper-block  .owl-item:not(.cloned)').length < 5 ) {
              containerExpertiseHome.trigger('destroy.owl.carousel').removeClass('owl-carousel');
            }

          }
        });
      }
    },

    /**
     * Block Col ServicesExpertise
     */

    blockSliderContainerServicesExpertise: function () {
      var containerExpertiseServices = $(' .paragraph--block-expertises--services .wrapper-block  .services--items-content');
      var params = {
        stagePadding: 0,
        margin: 30,
        loop: false,
        autoplay: false,
        nav: false,
        responsiveClass: true,
        dots: false,
        autoWidth: false,
        items:1,
      };

      // Init before resize
      if ($(window).width() < 768) {
        if($('.paragraph--block-expertises--services .services--items-content').length) {
          containerExpertiseServices.addClass('owl-carousel').owlCarousel(params);
        }
      }

      $(window).on('resize', function () {
        if ($(window).width() < 768 && !containerExpertiseServices.hasClass('owl-carousel')) {
          containerExpertiseServices.addClass('owl-carousel').owlCarousel(params);
        } else if ($(window).width() > 768) { // Not mobile but slider built = destroy
          if($('.paragraph--block-expertises--services .services--items-content').length) {
            containerExpertiseServices.trigger('destroy.owl.carousel').removeClass('owl-carousel');
          }
        }

      });
    },

    blockSliderContainerServicesFiliales: function () {
      var containerBlockFiliales = $('.paragraph--block-filiales .services--items-content');

      var params = {
        stagePadding: 0,
        margin: 30,
        loop: false,
        autoplay: false,
        nav: false,
        responsiveClass: true,
        dots: false,
        autoWidth: false,
        items:1,
      };

      // Init before resize
      if ($(window).width() < 768) {
        if($('.paragraph--block-filiales .services--items-content').length) {
          containerBlockFiliales.addClass('owl-carousel').owlCarousel(params);
        }
      }

      $(window).on('resize', function () {
        if ($(window).width() < 768 && !containerBlockFiliales.hasClass('owl-carousel')) {
          containerBlockFiliales.addClass('owl-carousel').owlCarousel(params);
        } else if ($(window).width() > 768) { // Not mobile but slider built = destroy
          if($('.paragraph--block-filiales .services--items-content').length) {
            containerBlockFiliales.trigger('destroy.owl.carousel').removeClass('owl-carousel');
          }
        }

      });
    },

    blockSliderContainerReference: function () {
      var params = {
        stagePadding: 0,
        margin:30,
        loop: false,
        autoplay: false,
        nav: true,
        responsiveClass: true,
        dots: false,
        // center:true,
        autoWidth: true,
        responsive: {
          0: {
            items: 1.2,
          },
          768: {
            items: 3.4,
          }
        }
      };


      if($('.paragraph-reference .paragraph').length >= 6){
        $('.paragraph-reference .owl').addClass('owl-carousel').owlCarousel(params);
      }

      var breakpointSlider = 767;
      // Init before resize
      if ($(window).width() < breakpointSlider) {
        $('.paragraph-reference .owl').addClass('owl-carousel').owlCarousel(params);
      }

      $(window).on('resize', function () {
        if ($(window).width() < breakpointSlider && !$('.paragraph-reference .owl').hasClass('owl-carousel')) {
          $('.paragraph-reference .owl').addClass('owl-carousel').owlCarousel(params);
        } else if ($(window).width() > breakpointSlider) { // Not mobile but slider built = destroy
          if($('.paragraph-reference .owl-item:not(.cloned)').length < 6 ) {
            $('.paragraph-reference .owl-carousel').trigger('destroy.owl.carousel').removeClass('owl-carousel');
          }
        }
      });
    },

    /**
     * Block Card News
     */
    blockSliderCardViewRefreshHandler: function (classView, breakpointSlider) {
      var containerViewCardNew = $('.'+classView+' .view-list');
      if( typeof(breakpointSlider) == 'undefined' ){
          breakpointSlider = 768;
      }
      var params = {
        loop: false,
        autoplay: true,
        responsiveClass: true,
        dots: false,
        autoWidth: false,
        responsive: {
          0: {
            items: 1.2,
            margin: 25,
          }
        }
      };

      // Init before resize
      if ($(window).width() < breakpointSlider) {
        containerViewCardNew.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).on('resize', function () {
        if ($(window).width() < breakpointSlider && !containerViewCardNew.hasClass('owl-carousel')) {
          containerViewCardNew.addClass('owl-carousel').owlCarousel(params);
        } else if ($(window).width() > breakpointSlider) { // Not mobile but slider built = destroy
          containerViewCardNew.trigger('destroy.owl.carousel').removeClass('owl-carousel');
        }
      });
    },

    /**
     * Block FAQ
     */
    blockFaqHandler: function () {
      $('body').on('click touch', '.paragraph--type--block-faq .field_question', function (e) {
        e.preventDefault();
        $(this).addClass('selected');
        $(this).closest('.paragraph--type--block-faq').find('.field_question:not(.selected)').removeClass('active');
        $(this).removeClass('selected').toggleClass('active');
      });
    },

    /**
     * Block video
     */
    blockVideoHandler: function () {
      $('body').on('click touch', '.paragraph--type--block-video-embed .block-video-embed--link.open-here', function (e) {
        e.preventDefault();
        $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
        $(this).closest('.paragraph--type--block-video-embed').addClass('play');
      });
    },

    /**
     * Gestionnaire de la navigation principale en responsive
     */
    formHandler: function () {
      var self = this;

      /*var valueSubject = '';
      var valueSubjectOf = '';
      var valueYour = '';
      var valueYourRequest = '';

      $('select[name="subject"]').on('change', function() {
        valueSubject = this.value;
      });

      $('select[name="subject_of"]').on('change', function() {
        valueSubjectOf = this.value;
      });

      $('select[name="your"]').on('change', function() {
        valueYour = this.value;
        $('#edit-your-request').prop('selectedIndex',0);
        if(valueYour == 18 || valueYour == 17) {
          $('#edit-container-global').hide();
        } else {
          $('#edit-container-global').show();
        }
      });

      $('#edit-your-request').on('change', function() {
        valueYourRequest = this.value;

        if(valueYourRequest == 'vente-de-terrain') {
          $('#edit-container-global').hide();
        }
        if(valueYourRequest == 'autres') {
          $('#edit-container-global').show();
        }
      });*/

      if (self.elements.formLandingPage.length) {
        self.elements.formMobileOpenLandingPage.click(self.callOpenFormLandingPageEvent);
        self.elements.formMobileCloseLandingPage.click(self.callCloseFormLandingPageEvent);
      }
    },

    /**
     * Gestionnaire du formulaire d'ouverture (version mobile) de la landing page
     */
    callOpenFormLandingPageEvent: function (e) {
      e.preventDefault();
      $("html").css({'overflow': 'hidden', 'position': 'fixed', 'height': '100%', 'width': '100%'});
      $("body").css({'overflow': 'hidden', 'position': 'fixed', 'height': '100%', 'width': '100%'});
      var heightScroll = window.innerHeight - $(".section-right-header").height();
      $('.content-page-landing-card-right').css({"transform": "translate(0px)", "height": "100vh"});
      var styles = {
        "height": heightScroll + "px",
        "overflow-x": "scroll",
        top: "0"
      };
      $('#form-landing-page').css(styles);
    },

    /**
     * Gestionnaire du formulaire de fermeture (version mobile) de la landing page
     */
    callCloseFormLandingPageEvent: function (e) {
      e.preventDefault();
      $("html").removeAttr('style');
      $("body").removeAttr('style');
      $('.content-page-landing-card-right').removeAttr('style');
      $('#form-landing-page').removeAttr('style');
    },

    /**
     * Gestionnaire de partage d'article par email
     */
    articleShareHandler: function () {
      $('#share-submit').click(function (e) {
        e.preventDefault();
        var button = $(this);
        var modal = button.parents('form');
        var alert_fields = $('.alert');
        if (alert_fields.length > 0) {
          alert_fields.each(function (field) {
            $(this).removeClass('alert');
          });
        }

        $.ajax({
          url: '/ajax/emailshare',
          type: 'POST',
          data: modal.serialize() + "&url=" + window.location.href,
          dataType: 'json',
          success: function (data) {
            if (data.errors.length > 0) {
              var errors_html = '';
              data.errors.forEach(function (error) {
                errors_html += error['message'] + '<br />';
                $('#' + error['error']).addClass('alert');
              });
              $('.errors').html(errors_html);
            } else {
              $('.container-modal-form').addClass('container-form').html('<h2 class="title3">Félicitations</h2><p>L’article a correctement été envoyée</p>');
            }
          },
          error: function (xhr, ajaxOptions, thrownError) {
            console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
          }
        });
      });
    },

    /**
     * Gestionnaire du modal du site
     */
    modalHandler: function () {
      var btnModalOpen = $('.btn-modal');
      var btnModalClose = $('.js-btn-close');

      if (btnModalOpen.length) {
        btnModalOpen.on('click', function (e) {
          e.preventDefault();
          var btnModalAttr = $(this).attr("data-modal");
          var modal = $("#" + btnModalAttr);
          $("#" + btnModalAttr + ' .btn-blue').attr("href", $(this).attr("href"));
          modal.addClass("open");
        });
      }
      if (btnModalClose.length) {
        btnModalClose.on('click', function (e) {
          e.preventDefault();
          var btnModalAttr = $(this).closest('div.open');
          var modal = $("#" + btnModalAttr[0].id);
          modal[0].classList.remove("open");
        });
      }
    },

    /**
     * Gestionnaire du footer en deux colonnes
     */
    navFooterHandler: function () {
      $('#block-drup-theme-menu-prefooter > ul').columnize();
    },

    /**
     * Block Galery
     */
    blockSearchHandler: function () {
      var self = this;
      $('body').on('click touch', '#icon-search', function (e) {
        e.preventDefault();
        $('.form--search').toggleClass('open');
      });
    },

};

}(jQuery, Drupal, drupalSettings));
